
import Sniffr from "sniffr";
import ShareitGood from "../assets/shareit-good.png";
import ShareitBad from "../assets/shareit-bad.png";
import ShareitSad from "../assets/shareit-sad.png";
import ShareitTip from "../assets/shareit-tip.png";
import OutlookIcon from "../assets/outlook-blue.png";
import GSuiteIcon from "../assets/gsuite.png";
import HangoutsIcon from "../assets/hangouts.png";
import GDocsIcon from "../assets/gdocs.png";
import GSheetsIcon from "../assets/gsheets.png";
import GSlidesIcon from "../assets/gslides.png";
import WebSearchIcon from '../assets/filter-web.png';
import GoogleChatIcon from "../assets/google-chat.png";

const _schnoz = new Sniffr();
if (process.env.BROWSER) {
	_schnoz.sniff(navigator.userAgent);
}

class Constants {
	// private
	static get _features() {
		return {
			V3: "V3",
			GMAIL: "Gmail",
			GOOGLE_HANGOUTS: "Google Hangouts",
			GOOGLE_DRIVE: "Google Drive",
			EXCHANGE: "Exchange",
			TIPS: "Tips",
			SOCIAL_MEDIA: "Social Media",
			MONTHLY_REPORTING: "MonthlyReporting",
			ACTIVITIES_RELOAD: "ActivitiesReload",
			DISCUSSIONS: "Discussions",
			REPORTING: "Reporting",
			ACCOUNT_CONFIG: "Account Config",
			EVENTS: "Events",
			EMAIL_SENTIMENT: "EmailSentiment",
			DISABLE_RATE_OPTION: "Disable Rate Option",
			STICKY_ACCOUNT_FILTER: "Sticky Account Filter",
			PATTERNS: "Patterns"			
		};
	}

	// private
	static get _permissions() {
		return {
			REPORTS: {
				APPLICATION: "reports.application",
				EMAIL: "reports.email"
			},

			DATA: {
				SOCIAL_MEDIA: "data.social_media",
				GSUITE: "data.gmail",
				EXCHANGE: "data.exchange",
				TIPS: "data.tips",
				// WEB_SEARCH: "data.web_search"
			},

			MANAGE: {
				USER: "manage.user",
				LOCAL: "manage.local",
				LOCATIONS: "manage.locations",
				NOTIFICATIONS: "manage.notifications"
			},

			WRITE: {
				CORP: "write.corp"
			}
		};
	}

	// private
	static get _integrations() {
		return {
			BTA: "bta",
			P3: "p3",
			CARE: "fusion"
		};
	}

	// private
	static get _sourceIds() {
		return {
			FACEBOOK: 1,
			INSTAGRAM: 4,
			TWITTER: 7,
			YOUTUBE: 9,
			REDDIT: 13,
			GMAIL: 14,
			SHAREIT: 15,
			EXCHANGE: 16,
			HANGOUTS_CHAT: 17,
			GOOGLE_DOCS: 18,
			GOOGLE_SHEETS: 19,
			GOOGLE_SLIDES: 20,
			// WEB_SEARCH: 22,
			GSUIT_COMMENT: "comment",
			GOOGLE_CHAT: 23
		};
	}

	static get _gsuiteSourceNames() {
		let obj = {};
		obj[Constants._sourceIds.GOOGLE_DOCS] = "Google Doc";
		obj[Constants._sourceIds.GOOGLE_SHEETS] = "Google Sheet";
		obj[Constants._sourceIds.GOOGLE_SLIDES] = "Google Slide";
		return obj;
	}

	static get _entityIds() {
		return {
			EVENT: 1,
			PERSON: 2,
			PLACE: 3
		};
	}

	// private
	static get _palette() {
		return {
			PRIMARY: {
				TAN: "#e8e5d6",
				LIME: "#99ec64",
				MAIN: "#007E8F",
				SEA_FOAM: "#007E8F",
				DARK_BLUE: "#2c3749",
				MIDNIGHT: "#1c2430",
				GREY: "#F4F5F5",
				MEDIUM_GREY: "#a1a8b1",
				BLACK: "#192025",
				DARK_GREY: "#29353D",
				LIGHT_GREY: "#D9DCDD",
				CYAN: "#006572",
				LIGHT_CYAN: "#007E8F",
				GREEN: "#4AAA00",
				LIGHT_BLUE: "#E6F2F4"
			},

			SECONDARY: {
				LIGHT_BLUE: "#78efe5",
				MUSTARD: "#e1d132",				
				PURPLE: "#504b8c",
				SLATE: "#34505E",
				WARNING_YELLOW: "#fffbe6",
				ORANGE: "#FF8310",
				GREY: "#697277",
				GREEN: "#5DD400",
				LIGHT_GREY: "#E4E7E7",
				LIGHT_CYAN: "#B3D8DD",
			},

			ACCESSIBILITY: {
				MAIN: "#007550",
				SECONDARY_TEXT_MORE_CONTRAST: "#636363",
				SECONDARY_TEXT: "#81888c",
				FORM_LABELS: "#757575"
			},

			PLACEHOLDER_BG: "#cdcdcd"
		};
	}

	static get APP_PATH(){
		return 'signals';
	}

	static get API_PATH(){
		return 'next';
	}

	static get PAGE_TITLE() {
		return 'Detect';
	}

	static get SCHNOZ() {
		return _schnoz;
	}

	static get COLORS() {
		return Constants._palette;
	}

	static get LOCAL_STORAGE() {
		return {
			CONTRAST: "more-contrast",
			RATE_IN_WORKFLOW: "rate-in-workflow"
		};
	}

	static get ERROR_VALIDATORS() {
		return {
			isPhone: 'matchRegexp:^[-() 0-9]*$',
			// When saving validation is rechecked with unmasked value, which is 10 digits so
			// regex needs formatting chars to be optional
			isPhoneWithMask: 'matchRegexp:^\\(?[1-9][0-9][0-9]\\)? ?[1-9][0-9][0-9]-?[0-9][0-9][0-9][0-9]$',
		};
	}

	static get ERROR_MESSAGES() {
		return {
			required: 'field is required',
			isEmail: 'must be valid email',
			isPhone: 'must be valid 10 digit phone number',
			unique: 'already exists'
		};
	}

	static get ENV() {
		return {
			IS_LIVE: process.env.REACT_APP_DEV_ENV === "prod",
			IS_STAGING: process.env.REACT_APP_DEV_ENV === "staging",
			IS_LOCAL: process.env.REACT_APP_DEV_ENV === "local",
			IS_MOBILE: process.env.BROWSER && /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()),
			IS_IOS: process.env.BROWSER && /iPad|iPhone|iPod/.test(navigator.userAgent),
			IS_IOS_LT113: process.env.BROWSER && /iPad|iPhone|iPod/.test(navigator.userAgent) && Constants.SCHNOZ.browser.version[0] < 11.3,
			IS_SAFARI: process.env.BROWSER && /^((?!chrome|crios|firefox|android).)*safari/i.test(navigator.userAgent),
			IS_EDGE: process.env.BROWSER && /edge/i.test(navigator.userAgent),
			IS_IE11: process.env.BROWSER && /ie/i.test(Constants.SCHNOZ.browser.name) && Constants.SCHNOZ.browser.version[0] === 11
		};
	}

	static get ACCOUNT() {
		return {
			VERTICAL: {
				K12: 1,
				HED: 2,
				PUBLIC_SAFETY: 3,
				OTHER: 4,
				ARENA: 5
			},

			FEATURES: Constants._features,
			INTEGRATIONS: Constants._integrations
		};
	}

	static get USER() {
		return {
			ROLES: {
				TEAM_MEMBER: {
					ID: 5,
					NAME: "Team Member"
				},

				ADMINISTRATOR: {
					ID: 3,
					NAME: "Administrator"
				}
			},

			AVATAR: {
				SIZE: {
					WIDTH: 144,
					HEIGHT: 144
				}
			},

			PERMISSIONS: Constants._permissions
		};
	}

	static get HELP() {
		return {
			URL: 'https://help.navigate360.com/en_US/DETECT',
			PHONE: '3306610106',
			EMAIL: 'tech@navigate360.com'
		};
	}

	static get ENTITIES() {
		return {
			IDS: Constants._entityIds,
			getName(type, plural) {
				switch(type) {
					case Constants.ENTITIES.IDS.EVENT:
						return `Event${plural ? "s" : ""}`;
					case Constants.ENTITIES.IDS.PERSON:
						return "People";
					case Constants.ENTITIES.IDS.PLACE:
						return `Place${plural ? "s" : ""}`;
					default: break;
				}
			}
		};
	}

	static get SOURCES() {
		return {
			WORDPRESS: "automattic",
			GMAIL: "gmail",
			GSUITE: "gsuite",
			HANGOUTS_CHAT: "hangouts_chat",
			GOOGLE_CHAT: "google_chat",
			EXCHANGE: "exchange",
			// WEB_SEARCH: "web_search",
			SHAREIT: "tips",
			TWITTER: "twitter",
			INSTAGRAM: "instagram",
			REDDIT: "reddit",
			YOUTUBE: "youtube",
			FACEBOOK: "facebook",
			SOCIAL_MEDIA: "social_media",


			// Currently, all source names match up with fontawesome icon names - except wordpress
			ICONS: {
				automattic: {
					sourceName: 'wordpress',
					icon: {icon: 'wordpress', color: '#238fbd'}
				},

				gsuite: {
					altName: "G Suite",
					icon: {image: GSuiteIcon, altText: "G Suite"}
				},

				gmail: {
					icon: {icon: 'envelope', type: 'fal', color: '#c71610'}
				},

				hangoutsChat: {
					altName: "Hangouts Chat",
					icon: {image: HangoutsIcon, altText: "Hangouts Chat"}
				},

				googleChat: {
					altName: "Google Chat",
					icon: {image: GoogleChatIcon, altText: "Google Chat"}
				},

				googleDocs: {
					altName: `${Constants._gsuiteSourceNames[Constants._sourceIds.GOOGLE_DOCS]}s`,
					icon: {image: GDocsIcon, useHeight: true, altText: `${Constants._gsuiteSourceNames[Constants._sourceIds.GOOGLE_DOCS]}s`}
				},

				googlePresentation: {
					altName: `${Constants._gsuiteSourceNames[Constants._sourceIds.GOOGLE_SLIDES]}s`,
					icon: {image: GSlidesIcon, useHeight: true, altText: `${Constants._gsuiteSourceNames[Constants._sourceIds.GOOGLE_SLIDES]}s`}
				},

				googleSpreadsheet: {
					altName: `${Constants._gsuiteSourceNames[Constants._sourceIds.GOOGLE_SHEETS]}s`,
					icon: {image: GSheetsIcon, useHeight: true, altText: `${Constants._gsuiteSourceNames[Constants._sourceIds.GOOGLE_SHEETS]}s`}
				},

				exchange: {
					altName: "Outlook",
					icon: {image: OutlookIcon, altText: 'Outlook'}
				},

				tips: {
					altName: "Shareit",
					icon: {image: ShareitGood, backgroundColor: '#FFC107', altText: 'Shareit - Good'}
				},

				shareitSad: {
					altName: "Shareit",
					icon: {image: ShareitSad, backgroundColor: '#57BCFA', altText: 'Shareit - Sad'}
				},

				shareitBad: {
					altName: "Shareit",
					icon: {image: ShareitBad, backgroundColor: '#ED412D', altText: 'Shareit - Bad'}
				},

				shareitTip: {
					altName: "Shareit",
					icon: {image: ShareitTip, backgroundColor: '#00CDB8', altText: 'Shareit - Tip'}
				},

				webSearch: {
					altName: "WebSearch",
					icon: {image: WebSearchIcon, useHeight: true, altText: 'Filter Web Search'}
				},

				twitter: {
					icon: {color: '#38A1F3'}
				},

				instagram: {
					icon: {color: '#0000000'}
				},

				reddit: {
					icon: {color: '#fd4314'}
				},

				youtube: {
					icon: {color: '#ff0000'}
				},

				facebook: {
					icon: {color: "#3C5A99"}
				}
			},

			IDS: Constants._sourceIds,

			// TODO: is there a backend source of truth?
			SOCIAL_MEDIA_IDS: [
				Constants._sourceIds.FACEBOOK,
				Constants._sourceIds.INSTAGRAM,
				Constants._sourceIds.TWITTER,
				Constants._sourceIds.YOUTUBE,
				Constants._sourceIds.REDDIT,
			],

			GSUITE_IDS: [
				Constants._sourceIds.GMAIL,
				Constants._sourceIds.HANGOUTS_CHAT,
				Constants._sourceIds.GOOGLE_DOCS,
				Constants._sourceIds.GOOGLE_SHEETS,
				Constants._sourceIds.GOOGLE_SLIDES,
				Constants._sourceIds.GSUIT_COMMENT,
				Constants._sourceIds.GOOGLE_CHAT
			],

			DISPLAY_NAMES: {
				automattic: "Wordpress",
				gmail: "Gmail",
				gsuite: "G Suite",
				hangouts_chat: "Hangouts Chat",
				exchange: "Outlook",
				tips: "Shareit",
				twitter: "Twitter",
				instagram: "Instagram",
				reddit: "Reddit",
				youtube: "YouTube",
				facebook: "Facebook",
				webSearch: "Filter Web Search",
				googleChat: "Google Chat"
			},

			GSUITE_DISPLAY_NAMES: Constants._gsuiteSourceNames,

			FILTER_MAP: [{
				id: "social_media",
				name: "Social Media",
				selected: true, // for FilterField
				permission: Constants._permissions.DATA.SOCIAL_MEDIA
			},{
				id: "gsuite",
				name: "G Suite",
				selected: true, // for FilterField
				features: [Constants._features.GMAIL, Constants._features.GOOGLE_HANGOUTS, Constants._features.GOOGLE_DRIVE],
				permission: Constants._permissions.DATA.GSUITE
			},{
				id: "exchange",
				name: "Outlook",
				selected: true, // for FilterField
				features: [Constants._features.EXCHANGE],
				permission: Constants._permissions.DATA.EXCHANGE
			},{
				id: "tips",
				name: "Shareit",
				selected: true, // for FilterField
				features: [Constants._features.TIPS],
				permission: Constants._permissions.DATA.TIPS
			}],

			getAuthorized(authenticatedUser) {
				return Constants.SOURCES.FILTER_MAP.reduce((sources, source) => {
					if (authenticatedUser && authenticatedUser.permissions.includes(source.permission)) {
						if (!source.features) {
							sources.push(source);
						} else {
							if (source.features.some(feature => authenticatedUser.accountFeatures.includes(feature))) {
								sources.push(source);
							}
						}
					}
					return sources;
				}, []);
			},

			getDisplayNameFromId(sourceId) {
				let ids = Constants.SOURCES.IDS,
					sourceKey = (
						sourceId === ids['GOOGLE_DOCS'] ||
						sourceId === ids['GOOGLE_SHEETS'] ||
						sourceId === ids['GOOGLE_SLIDES']
					) ? 'GSUITE' : Object.keys(ids).find(key => ids[key] === sourceId);

				return Constants.SOURCES.DISPLAY_NAMES[Constants.SOURCES[sourceKey]];
			},

			getSourceIcon(activity) {
				let icon, config;
				if (activity.source.name) {
					if (activity.source.name === "tips") {
						if(!activity.tip) {
							console.warn('Tip missing');
							console.warn(activity);
							config = Constants.SOURCES.ICONS.tips;
						} else {
							let {action} = activity.tip;
							const actionSource = {
								share_positive: 'tips',
								share_uncertain: 'shareitSad',
								share_negative: 'shareitBad',
								share_tip: 'shareitTip'
							};
							config = Constants.SOURCES.ICONS[actionSource[action]];
						}
					} else {
						config = Constants.SOURCES.ICONS[activity.source.name];
					}
					activity.source.name = config && config.sourceName || activity.source.name;
					if(!(config && "icon" in config && config.icon && "image" in config.icon && config.icon.image)) {
						icon = Object.assign({icon: activity.source.name}, config ? config.icon : {});
					} else {
						icon = Object.assign({}, config.icon);
					}
				}
				return icon;
			}
		};
	}

	static get LOCATION() {
		return {
			STATUSES: [{
				id: "active",
				name: "Active",
			},{
				id: "inactive",
				name: "Inactive"
			}],

			RESTRICTIONS: [
				'church',
				'mosque',
				'islamic',
				'temple',
				'synagogue'
			]
		};
	}

	static get REPORT() {
		return {
			DAYS: [{
				id: 7,
				name: "7 Days",
			},{
				id: 30,
				name: "30 Days",
			},{
				id: 60,
				name: "60 Days",
			},{
				id: 90,
				name: "90 Days",
			},{
				id: 180,
				name: "180 Days",
			},{
				id: 360,
				name: "360 Days",
			}],
		};
	}

	static get ACTIVITY() {
		return {
			CATEGORIES: {
				ALERTS: {
					ID: 1,
					NAME: 'alert',
					FILTER: {
						ID: "alerts",
						NAME: "Alerts"
					}
				},

				DISCUSSIONS: {
					ID: 2,
					NAME: 'discussion',
					FILTER: {
						ID: "discussions",
						NAME: "Discussions"
					}
				},

				SAVED: {
					ID: 3,
					NAME: 'saved',
					FILTER: {
						ID: "saved",
						NAME: "Saved"
					}
				}
			},

			EMAIL: {
				FROM_REGEX: new RegExp(/^([^<]*)(<[^>]*>)$/)
			},

			AUDIT_TRAIL: {
				SHARE: {
					ID: "share",
					ICON: "share",
					//COLOR: Constants._palette.PRIMARY.BRIGHT_GREEN
				},

				REMOVE: {
					ID: "remove",
					ICON: "trash-alt",
					//COLOR: Constants._palette.SECONDARY.PURPLE
				},

				SAVE: {
					ID: "save",
					ICON: "bookmark",
					//COLOR: Constants._palette.SECONDARY.YELLOW
				},

				COMMENT: {
					ID: "comment",
					ICON: "comment-alt-lines",
					//COLOR: "#2069be"
				},

				RATE: {
					ID: "rate",
					ICON: "abacus",
					//COLOR: Constants._palette.SECONDARY.ORANGE
				},

				VIEW: {
					ID: "view",
					ICON: "eye",
					//COLOR: Constants._palette.PRIMARY.BRIGHT_GREEN
				},

				STATUS_CHANGE: {
					ID: "status_change",
					ICON: "arrow-from-left",
					//COLOR: Constants._palette.PRIMARY.BRIGHT_GREEN
					getText(status) {
						let obj = Constants.ACTIVITY.STATUSES[
							Object.keys(Constants.ACTIVITY.STATUSES).filter(key => Constants.ACTIVITY.STATUSES[key].ID === status)
						];
						return obj?.NAME;
					}
				},

				CARE_STATUS_CHANGE: {
					ID: "care_status_change",
					ICON: "arrow-from-left",
					//COLOR: Constants._palette.PRIMARY.BRIGHT_GREEN
					getText(status) {
						let obj = Constants.ACTIVITY.CARE_STATUSES[
							Object.keys(Constants.ACTIVITY.CARE_STATUSES).filter(key => Constants.ACTIVITY.CARE_STATUSES[key].ID === status)
						];
						return obj.ACTION;
					}
				},

				REPORT_TO_BTA: {
					ID: "report_to_bta",
					ICON: "folder-upload",
					ICON_STYLES: {fontSize: "1.2rem"},
					getText: () => "reported"
				},

				REPORT_TO_P3: {
					ID: "report_to_p3",
					ICON: "folder-upload",
					ICON_STYLES: {fontSize: "1.2rem"},
					getText: () => "reported"
				}
			},

			RATINGS: {
				NO: 1,
				YES: 2,
				MAYBE: 3
			},

			STATUSES: {
				ANY: {
					ID: 0,
					NAME: "Any Signal"
				},
				NEW: {
					ID: 1,
					NAME: "New Signals"
				},
				FOR_REVIEW: {
					ID: 2,
					NAME: "For Review"
				},
				ESCALATED: {
					ID: 3,
					NAME: "Escalated"
				},
				RESOLVED: {
					ID: 4,
					NAME: 'Resolved'
				}
			},

			CARE_STATUSES: {			
				NOT_SHARED: {
					ID: 0,
					NAME: "Not Shared with CARE",
					ACTION: "unshared this alert from CARE"
				},
				SHARED: {
					ID: 1,
					NAME: "Shared with CARE",
					ACTION: "shared this alert with CARE"
				},
				RESOLVED: {
					ID: 2,
					NAME: "Resolved in CARE",
					ACTION: "resolved this alert in CARE"
				},
				REVOKED: {
					ID: 3,
					NAME: "Revoked from CARE",
					ACTION: "revoked this alert from CARE"
				}
			},

			GROUPED_IDS: [
				Constants._sourceIds.GOOGLE_DOCS
			],

			SHARE_TYPES: {
				EMAIL: 1,
				TEXT_MSG: 2,
				REPORT_TO_BTA: 3,
				REPORT_TO_P3: 4
			},

			TWITTER_REDACTION: {
				DELETE: "status_delete",
				WITHHELD: "status_withheld",
				USER_DELETE: "user_delete",
				USER_PROTECT: "user_protect",
				USER_SUSPEND: "user_suspend",
				USER_WITHHELD: "user_withheld",
				SCRUB_GEO: "scrub_geo",
				getMessage(reason, isShort) {
					let msgs = {};

					if (isShort) {
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.DELETE] = "This content is no longer available.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.WITHHELD] = "This content is no longer available.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.USER_DELETE] = "This content is no longer available.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.USER_PROTECT] = "This content is no longer available.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.USER_SUSPEND] = "This content is no longer available.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.USER_WITHHELD] = "This content is no longer available.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.SCRUB_GEO] = "Geodata is no longer available.";
					} else {
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.DELETE] = "This content is no longer available because the author deleted the post.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.WITHHELD] = "This content is not available because it is being withheld due to country of origin.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.USER_DELETE] = "This content is no longer available because the author deleted their account.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.USER_PROTECT] = "This content is no longer available because the author has protected their account.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.USER_SUSPEND] = "This content is no longer available because the author's account was suspended.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.USER_WITHHELD] = "This content is no longer available because it is being withheld due to the author's identification in a specific country.";
						msgs[Constants.ACTIVITY.TWITTER_REDACTION.SCRUB_GEO] = "Geodata is no longer available because the author has disabled location services.";
					}

					return msgs[reason];
				}
			},

			ACTION_BUTTONS: {
				getRemove(obj) {
					return Object.assign({
						label: "Remove",
						icon: ["fas", "minus-circle"],
						primary: true,
						color: "primary"
					}, obj);
				},

				getSave(obj) {
					return Object.assign({
						label: obj.flagged ? "Unsave" : "Save",
						icon: [obj.flagged ? "fas" : "fal", "bookmark"],
						primary: true,
						color: "primary"
					}, obj);
				},

				getShare(obj) {
					return Object.assign({
						label: "Share",
						icon: ["fas", "paper-plane"],
						primary: true,
						color: "primary"
					}, obj);
				},

				getRate(obj) {
					return Object.assign({
						label: obj && obj.rated ? "Rerate" : "Rate",
						icon: [obj && obj.rated ? "fas" : "fal", "thumbs-up"],
						primary: true,
						color: "primary",
						tooltip: "It's very quick to rate an alert and helps us train our AI-powered Language Engine to be more responsive to your community."
					}, obj);
				}
			},

			isDeleted(user, activity) {
				let prevRemoved,
					hiddenFor = user ? user.id : null,
					hiddenForUsers = activity.hidden_for_users;

				if (hiddenForUsers && hiddenForUsers.length) {
					prevRemoved = hiddenForUsers.find((obj) => {
						return obj.user.id === hiddenFor;
					});
				}

				return prevRemoved ? true : false;
			},

			hasViewed(user, views) {
				return views.find(obj => obj.userId === user.id) ? true : false;
			}
		};
	}

	static get PATTERN() {
		return {
			STATUSES: {
				ACTIVE: "active",
				INACTIVE: "inactive",
			},

			SHARE_TYPES: {
				EMAIL: 1,
				TEXT_MSG: 2,
				REPORT_TO_BTA: 3
			},

			ACTION_BUTTONS: {
				getShare(obj) {
					return Object.assign({
						label: "Share",
						icon: ["fal", "share"],
						primary: true,
						color: "primary"
					}, obj);
				}
			},

			isDetectionDate(pattern, activityTime) {
				return pattern && pattern.detectedAt === activityTime;
			}
		};
	}

	static get EVENT() {
		return {
			STATUSES: [{
				id: "past",
				name: "Past",
			},{
				id: "active",
				name: "Active"
			},{
				id: "future",
				name: "Future"
			}]
		};
	}

	static get SERVICES() {
		return {
			SENTIMENT: {
				LIVE: "https://4z9rn7nemg.execute-api.us-east-1.amazonaws.com/v1/student-sentiment",
				STAGING: "https://aahhbighx3.execute-api.us-east-1.amazonaws.com/v1/student-sentiment",
				getUrl() {return !Constants.ENV.IS_LIVE ? Constants.SERVICES.SENTIMENT.STAGING : Constants.SERVICES.SENTIMENT.LIVE;}
			},

			NATIONAL_TRENDING_TOPICS: {
				LIVE: "https://4z9rn7nemg.execute-api.us-east-1.amazonaws.com/v1/trending-topics",
				STAGING: "https://aahhbighx3.execute-api.us-east-1.amazonaws.com/v1/trending-topics",
				getUrl() {return !Constants.ENV.IS_LIVE ? Constants.SERVICES.NATIONAL_TRENDING_TOPICS.STAGING : Constants.SERVICES.NATIONAL_TRENDING_TOPICS.LIVE;}
			}
		};
	}

}

export default Constants;